import * as Yup from 'yup';

export type TransactionType = {
  id?: string;
};

export type CashTransactionFormType = {
  transactionAt: Date | null;
  tempTransactionAt: Date | null;
  needApproval: boolean;
  cashAccountId: string | null;
  type: string | null;
  amount: number;
  description: string;
  number?: string;
  transactionCategoryId: string | null;
};

export const cashTransactionSchema = () =>
  Yup.object()
    .shape({
      transactionCategoryId: Yup.string().nullable().required(),
      transactionAt: Yup.date().nullable().required(),
      cashAccountId: Yup.string().nullable().required(),
      type: Yup.string().nullable().required(),
      amount: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(0)
        .required(),
      description: Yup.string().nullable(),
      refId: Yup.string(),
    })
    .required();
